import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  /** Stagger index for the entrance animation. */
  index?: number;
  className?: string;
}

/** Ruled engineering panel: hairline border, quiet lift, no glow. */
const Card = ({ children, index = 0, className = '' }: CardProps): JSX.Element => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.5, delay: index * 0.08 }}
    className={`rounded-md border border-[color:var(--hairline)] bg-[color:var(--panel)] p-6 shadow-panel transition-colors duration-200 hover:border-primary-dark dark:hover:border-primary ${className}`}
  >
    {children}
  </motion.div>
);

export default Card;
